import { makeStyles } from "@mui/styles";
import { palette } from '../../../theme/doctorTheme'

export default makeStyles((theme: any) => ({
    container: {
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '24px',
        flexDirection: 'column',
    },
    main: {
        maxWidth: '600px',
        display: 'flex',
        padding: '54px 44px 34px 44px',
        flexDirection: 'column',
        gap: '34px',
    },
    title: {
        fontSize: '26px',
        fontWeight: 'bold',
        width: '400px',
        lineHeight: '34px',
    },
    text: {
        fontSize: '16px',
        fontWeight: '600',
        lineHeight: '24px',
    },
    logoWrapper: {},
    logo: {
        minWidth: '200',
        alignSelf: 'center',
        height: '30px',
    },
    icons: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '2rem',
        height: '183px',
        justifySelf: 'stretch',
    },
    logoutButton: {
        alignSelf: 'strecth',
        backgroundColor: palette.typography.main,
        color: palette.secondary.contrastText,
        '&:hover': {
            backgroundColor: palette.typography.half,
        },
    },
    footer: {
        padding: '0.5rem 1rem',
        display: 'flex',
        gap: '1rem',
        flexDirection: 'row',
        alignItems: 'center',
        [theme.breakpoints.up('lg')]: {
            position: 'absolute',
            bottom: '3rem',
            right: '3rem',
            maxWidth: '240px',
        },
    },
    footerLogoWrapper: {
        width: '24px',
        height: '24px',
    },
    footerLogo: {
        height: '1rem',
        aspectRatio: 1,
    },
    footerText: {
        flexShrink: 1,
        fontWeight: 'bold',
        '& a': {
            color: palette.common.main,
        },
    },
}))
